import { kernelStorageClient } from "../../../../../api/services";
import {
  CorgiModeActionKey,
  KittyModeActionKey,
} from "../../../actions/ActionKeys";
import { CorgiModeAction, KittyModeAction } from "../../../actions/corgiMode";

const persistedCorgiMode: boolean = kernelStorageClient.readCorgiMode();

/** The corgi mode redux state (also persisted to local storage). */
export const corgiModeEnabled = (
  state: boolean = persistedCorgiMode,
  action: CorgiModeAction
): boolean => {
  switch (action.type) {
    case CorgiModeActionKey.SET_CORGI_MODE:
      return action.payload.enabled;
    default:
      return state;
  }
};

const persistedKittyMode: boolean = kernelStorageClient.readKittyMode();

/** The kitty mode redux state (also persisted to local storage). */
export const kittyModeEnabled = (
  state: boolean = persistedKittyMode,
  action: KittyModeAction
): boolean => {
  switch (action.type) {
    case KittyModeActionKey.SET_KITTY_MODE:
      return action.payload.enabled;
    default:
      return state;
  }
};
